import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { UserState, Vehicule } from '@client/utils/shared-constants';
import firebase from 'firebase';
import User = firebase.User;
import {EMPTY, from, Observable} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';

@Injectable()
export class UserVehiclesService {
  itemsRef: AngularFireList<UserState> | Observable<never>;

  constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {
    auth.authState
      .pipe(
        tap((u: User) => {
          this.itemsRef = u ? this.db.list<UserState>(`/user/${u.uid}/vehicles`) : EMPTY;
        })
      )
      .subscribe();
  }

  hydrate() {
    return this.auth.user.pipe(
      switchMap((u: User) => u ? this.db.object<Vehicule[]>(`/user/${u.uid}/vehicles`).valueChanges() : EMPTY)
    );
  }
}
